<template>
  <NuxtLink :to="useCalcedLink?.(props.blok)">
    <OriginalButton
      v-bind="props"
      @click="click"
    />
  </NuxtLink>
</template>
<script lang="ts" setup>
import { useCalcedLink } from '~/composables/useCalcedLink'
import { type BlokProps, WPElementButton as OriginalButton, type ButtonBlok } from '@webcarelbj/shared-bloks'
import type { ButtonEmits } from '@webcarelbj/shared-components'

const { toSystemFriendlyString } = usePflegeUtils()
const { trackClick } = useTracking()

const props = defineProps<BlokProps<ButtonBlok>>()

const emit = defineEmits<ButtonEmits>()

const click = (event: MouseEvent) => {
  trackClick(props.blok, 'button', `btn_${toSystemFriendlyString(props.blok.label)}`, props.blok.mainComponentTrackingLabel)
  emit('click', event)
}
</script>
